import React, { useState, useEffect }  from 'react';
import { DataGrid } from '@mui/x-data-grid';
import stileGrid from '../../../interfaccia/stileGrid';
import CodiceVSVoceCliccabile from '../../../navigadbsections/CodiceVSVoceCliccabile';
import CodicePSVoceCliccabile from '../../../navigadbsections/CodicePSVoceCliccabile';

function ListaProblemi({setProductFunction,listaProblemi,setAnteprimaProdotto,setIDPSdiverso,utente}) {
  
  const [rows,setRows] = useState(
    listaProblemi
  )

  useEffect(() => {
    setRows(listaProblemi)
  },[listaProblemi]);



  const columns = [
    {
      field: 'codVS',
      headerName: 'Cod VS',
      width: 100,
      renderCell: (params) => {
        if (params.row.codVS) {
           return <CodiceVSVoceCliccabile codiceVS={params.row.codVS} setProductFunction={setAnteprimaProdotto} utente={utente} /> } 
           else { return <div className="rowitem">X</div> }      }
    },
    {
      field: 'codPS',
      headerName: 'Cod PS',
      width: 100,
      renderCell: (params) => {
        if (params.row.codPS) {
           return <CodicePSVoceCliccabile 
            codVS={params.row.codVS}
            codPS={params.row.codPS}
            codProd={params.row.codProduttore}
            titIT={params.row.name_IT}
            brand={params.row.Brand}
            setProductFunction={setProductFunction}
            setIDPSdiverso={setIDPSdiverso}
            utente={utente} /> } 
           else { return <div className="rowitem">X</div> }      }
    },
    {
      field: 'codProduttore',
      headerName: 'Cod Produttore',
      width: 200,
      valueGetter: (params) => {
        if (!params.value) {
          return 'X';
        }
        return params.value;
      }
    },
    {
      field: 'Brand',
      headerName: 'Produttore',
      width: 150,
      valueGetter: (params) => {
        if (!params.value) {
          return 'X';
        }
        return params.value;
      }
    },
    {
      field: 'name_IT',
      headerName: 'Nome',
      width: 450,
      valueGetter: (params) => {
        if (!params.value) {
          return 'X';
        }
        return params.value;
      }
    },
    {
      field: 'noBrand',
      headerName: 'BRAND',
      width: 80,
      valueGetter: (params) => {
        if (params.value == 0) {
          return '';
        }
        return `X`;
      }
    },
    {
      field: 'noImm',
      headerName: 'IMM',
      width: 70,
      valueGetter: (params) => {
        if (params.value == 0) {
          return '';
        }
        return `X`;
      }
    },
    {
      field: 'noTradEN',
      headerName: 'EN',
      width: 70,
      valueGetter: (params) => {
        if (params.value == 0) {
          return '';
        }
        return `X`;
      }
    },
    {
      field: 'noTradFR',
      headerName: 'FR',
      width: 70,
      valueGetter: (params) => {
        if (params.value == 0) {
          return '';
        }
        return `X`;
      }
    }
  ];

  return (
    <div
      className="colonnaTuttaPagina"
    >
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.codPS}
        autoPageSize
        rowsPerPageOptions={[10, 20, 50]}
                
        
        pagination
        sx={stileGrid}
        getCellClassName={(params) => {
          if (params.value === 'X') {
            return "cellaProblema tc";
          }
        }}
      />
      <small>Clicca su codVS per anteprima codVS, clicca su codPS per modificare l'articolo</small>
    </div>
  )
}


export default ListaProblemi;


